import {createApi} from "@reduxjs/toolkit/query/react";
import api from "@/store/api/api";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";

export const rolesApi = createApi({
    reducerPath: 'rolesApi',
    tagTypes: ['roles'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getRolesAndPermissions: build.query({
            query: (data) => ({
                url: api.roles.getRolesAndPermissions(),
                method: 'GET',
                params: data
            }),
            providesTags: ['roles'],
        }),
        getDefaultPermissions: build.query({
            query: () => ({
                url: api.roles.getDefaultPermissions(),
                method: 'GET',
            }),
        }),
        storeRolesAndPermissions: build.mutation({
            query: (data) => ({
                    url: api.roles.storeRolesAndPermissions(),
                    method: 'POST',
                    body: data
            }),
            invalidatesTags: ['roles']
        }),
    })
})

export const { useLazyGetRolesAndPermissionsQuery, useLazyGetDefaultPermissionsQuery } = rolesApi
